export default __webpack_public_path__ + "static/media/sale.de70277f.jpg";